<!-- promotions.vue -->

<template>
	<div>
		
	<div
		class="ui-promotions-wrapper ui-detail-common"
		v-if="mansong_info"
	>

		
		<!-- 展示促销信息 -->
		<div class="promotions-body">
			<div
				class="body-list"
				v-for="(item, index) in mansong_info.rules"
				:key="index"
			>
				<span>满{{ item.mansongrule_price }}立减现金{{ item.mansongrule_discount }}</span>
				<span v-if="item.goods_id && item.goods_storage" @click="$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': item.goods_id } })">，送礼品 {{item.mansong_goods_name}}</span>

			</div>
			
		</div>
		<div class="time-body">
			<div class="pt-10 pb-10">还剩<span class="day" v-if="day">{{ day }}天</span></div>
			<div class="time-wrapper">
				<span class="time" style="margin-left:0">{{ hours }}</span
				>&nbsp;时&nbsp;<span class="time">{{ minute }}</span
				>&nbsp;分&nbsp;<span class="time">{{ second }}</span
				>&nbsp;秒
			</div>
		</div>
	</div>
		

	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
		flag: false,
		day: '',
		hours: '',
		minute: '',
		second: '',
		time: '',
    }
  },
  mounted () {
    this.time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(this.time)
      } else {
        this.timeDown()
      }
    }, 1000)
  },
  computed: {
    ...mapState({
      mansong_info: state => state.goodsdetail.mansongInfo
    })
  },

  methods: {
   /*
	 * timeDown: 倒计时
	 */
    timeDown () {
      if (
        this.mansong_info
      ) {
        const endTime = new Date(this.mansong_info.mansong_endtime * 1000)
        const nowTime = new Date()
        let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
        this.day = parseInt(leftTime / (24 * 60 * 60))
        this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
        this.minute = this.formate(parseInt((leftTime / 60) % 60))
        this.second = this.formate(parseInt(leftTime % 60))
        if (leftTime <= 0) {
          this.flag = true
          this.$emit('time-end')
        }
      }
    },

    /*
	 * 格式化时间
	 */
    formate (time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-promotions-wrapper{margin-bottom:$modelSpace;display: flex;height:7.5rem;background-color: #fff;margin-top:$modelSpace;
	.promotions-body{width:6rem;background-image:url(../../../../assets/image/home/oval.png);background-size:6rem;background-repeat:no-repeat;background-position:left top;font-size:$fontSize;padding-top:3rem;padding-left:$pageSpace;
	.body-list{padding-top:.5rem;color:$descTextColor;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
	}
	.time-body{flex:1;font-size:$subFontSize;padding-left:.5rem;
		.day{color:$primaryColor;margin-left:.2rem;}
		.time-wrapper{display: flex;align-items: center;
		.time{width:1.5rem;height:1.5rem;margin:0 .1rem;font-size:1rem;line-height:1.5rem;background:$subColor;border:1px solid $primaryColor;border-radius:.2rem;color:$primaryColor;text-align:center;}
	}
	}
}

</style>
